const CONFIG = {
  css: {
    class: 'product-table',
    links: ['manufacturer-sku', 'sku'],
  },
};

export default CONFIG;
